import api from './api';

// Budget submission sign-offs (bud_submissions). Version + site travel in the
// request context headers; only the module is passed here.
export const submissionService = {
  getSubmission: async (module) => {
    const res = await api.get('/submissions', { params: { module } });
    return res.data;
  },
  submit: async (module) => {
    const res = await api.post('/submissions', { module });
    return res.data;
  },
  withdraw: async (module) => {
    const res = await api.delete('/submissions', { params: { module } });
    return res.data;
  },
};

export default submissionService;
